import { OscViewComponent } from "./proponente/osc-view/osc-view.component";
import { ConcedenteViewComponent } from "./concedente/concedente-view/concedente-view.component";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ModuloNaoDisponivelComponent } from "./core/not-found/modulo-nao-disponivel.component";
import { HomePageComponent } from "./home/home/home-page.component";
import { UsuarioViewComponent } from "./home/info/usuario-view/usuario-view.component";
import { MapaComponent } from "./mapa/mapa.component";
import { AuthGuard } from "./seguranca/auth.guard";
import { LoginFormComponent } from "./seguranca/login-form/login-form.component";
import { WrapperComponent } from "./wrapper/wrapper.component";
import { EntidadeViewComponent } from "./home/info/entidade-view/entidade-view.component";
import { TutoriaisComponent } from "./tutoriais/tutoriais.component";
import { AssinadorDocumentosComponent } from "./assinador-documentos/assinador-documentos.component";
import { ConsultaPublicaTutoriaisComponent } from "./tutoriais/consulta-publica/consulta-publica-tutoriais.component";

const routes: Routes = [
  { path: "login", component: LoginFormComponent },
  { path: "mapa", component: MapaComponent, canActivate: [AuthGuard] },
  {
    path: "outras-opcoes",
    loadChildren: () => import('app/outras-opcoes/outras-opcoes.module').then(m => m.OutrasOpcoesModule),
  },
  { path: 'matricula', loadChildren: () => import('app/modulo-escolar/matricula-publica/matricula-publica.module').then(m => m.MatriculaPublicaModule) },

  // O portal da transparência fica FORA do bloco protegido pelo AuthGuard, de propósito:
  // uma área pública atrás de login não é uma área pública (ADR-0018).
  {
    // A verificacao de assinatura (ADR-0030). PUBLICA, sem AuthGuard: um PDF
    // assinado que so o proprio sistema sabe validar nao serve para quem recebe.
    // Mesma razao da area publica da ADR-0018.
    path: "validar-assinatura",
    loadChildren: () => import('app/assinatura/validar-assinatura.module')
        .then(m => m.ValidarAssinaturaModule),
  },

  {
    path: "transparencia",
    loadChildren: () => import('app/transparencia/transparencia.module').then(m => m.TransparenciaModule),
  },
  {
    path: "",
    component: WrapperComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "home", component: HomePageComponent, canActivate: [AuthGuard] },
      {
        path: "usuario-view",
        component: UsuarioViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "entidade-view",
        component: EntidadeViewComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: "concedente",
            component: ConcedenteViewComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "proponente",
            component: OscViewComponent,
            canActivate: [AuthGuard],
          },
        ],
      },

      // ===== LAZY-LOADINGS ==== //
      { path: "mapa", component: MapaComponent, canActivate: [AuthGuard] },

      {
        path: "tutoriais",
        component: TutoriaisComponent,
        canActivate: [AuthGuard],
      },

      {
        path: "assinador-documentos",
        component: AssinadorDocumentosComponent,
        canActivate: [AuthGuard],
      },

      {
        path: "cadastros",
        loadChildren: () => import('app/cadastros/cadastros.module').then(m => m.CadastrosModule),
      },

      {
        path: "relatorios",
        loadChildren: () => import('app/relatorios/relatorios.module').then(m => m.RelatoriosModule),
      },

      {
        path: "financeiro",
        loadChildren: () => import('app/financeiro/financeiro.module').then(m => m.FinanceiroModule),
      },

      {
        path: "contabilidade",
        loadChildren: () => import('app/contabilidade/contabilidade.module').then(m => m.ContabilidadeModule),
      },

      {
        path: "editais-credenciamento",
        loadChildren: () => import('app/edital-credenciamento/edital-credenciamento.module').then(m => m.EditalCredenciamentoModule),
      },

      {
        path: "editais-recadastramento",
        loadChildren: () => import('app/edital-credenciamento/edital-credenciamento.module').then(m => m.EditalCredenciamentoModule),
      },

      {
        path: "editais-chamamento",
        loadChildren: () => import('app/edital-chamamento/editalChamamento.module').then(m => m.EditalChamamentoModule),
      },

      {
        path: "notificacao",
        loadChildren: () => import('app/notificacao/notificacao.module').then(m => m.NotificacaoModule),
      },

      {
        path: "suporte",
        loadChildren: () => import('app/suporte/suporte.module').then(m => m.SuporteModule),
      },

      {
        path: "base-conhecimento",
        loadChildren: () => import('app/base-conhecimento/base-conhecimento.module').then(m => m.BaseConhecimentoModule),
      },

      {
        path: "audesp",
        loadChildren: () => import('app/audesp/audesp.module').then(m => m.AudespModule),
      },
      {
        // Carga massiva (ADR-0022): dentro do bloco autenticado, e ainda
        // protegida por ROLE_CARGA_MASSIVA no proprio recurso.
        path: "carga-massiva",
        loadChildren: () => import('app/carga-massiva/carga-massiva.module').then(m => m.CargaMassivaModule),
      },
      {
        // Tipos de Programa (ADR-0023): protegido tambem por
        // ROLE_GERENCIAR_TIPO_PROGRAMA no proprio recurso.
        path: "tipos-de-programa",
        loadChildren: () => import('app/tipos-de-programa/tipos-de-programa.module').then(m => m.TiposDeProgramaModule),
      },
      {
        // Assinatura digital ICP-Brasil, dentro do sistema (ADR-0030).
        path: "assinatura",
        loadChildren: () => import('app/assinatura/assinatura.module').then(m => m.AssinaturaModule),
      },

      {
        path: "mensageria",
        loadChildren: () => import('app/mensageria/mensageria.module').then(m => m.MensageriaModule),
      },

      {
        // Classificação da despesa (ADR-0025): custos diretos/indiretos e
        // previsto × realizado.
        path: "classificacao-despesa",
        loadChildren: () => import('app/classificacao-despesa/classificacao-despesa.module').then(m => m.ClassificacaoDespesaModule),
      },

      {
        // Anexos da IN 01/2020 do TCE-SP (ADR-0033). Exige ROLE_AUDESP, a mesma
        // permissão da importação do AUDESP: é o mesmo dever, da controladoria.
        path: "relatorios-tce",
        loadChildren: () => import('app/tce/tce.module').then(m => m.TceModule),
      },

      {
        // Deteccao de reuso de nota fiscal (ADR-0041, edital TR 5.5 l.16-l.20). Exige
        // ROLE_AUDESP: o relatorio aponta dinheiro possivelmente contado duas vezes, e
        // a permissao de ver despesa esta em 50 perfis -- ela nao trancaria nada.
        path: "notas-fiscais",
        loadChildren: () => import('app/notas-fiscais/notas-fiscais.module')
          .then(m => m.NotasFiscaisModule),
      },

      {
        // Remessa CNAB 240 de pagamento em lote (ADR-0044, edital TR 5.5 l.6). Exige
        // ROLE_VISUALIZAR_ORDEM_BANCARIA -- a de quem emite ordem de pagamento, que e
        // o que este arquivo e.
        path: "remessa-cnab",
        loadChildren: () => import('app/cnab/cnab.module').then(m => m.CnabModule),
      },

      {
        // Fluxos de processo em BPMN 2.0 (ADR-0034). Ler é de quem está logado;
        // desenhar exige ROLE_GERENCIAR_TIPO_PROGRAMA. NÃO é motor de workflow.
        path: "fluxos-bpmn",
        loadChildren: () => import('app/fluxo-bpmn/fluxo-bpmn.module').then(m => m.FluxoBpmnModule),
      },

      {
        path: "dispensa-inexigibilidade",
        loadChildren: () => import('app/dispensa-inexigibilidade/dispensaInexigibilidade.module').then(m => m.DispensaInexigibilidadeModule),
      },

      {
        path: "preparacao",
        loadChildren: () => import('app/preparacao/preparacao.module').then(m => m.PreparacaoModule),
      },

      {
        path: "projetos",
        loadChildren: () => import('app/projetos/projeto.module').then(m => m.ProjetoModule),
      },

      {
        path: "celebracao",
        loadChildren: () => import('app/celebracao/celebracao.module').then(m => m.CelebracaoModule),
      },

      { path: "planos", loadChildren: () => import('app/plano/plano.module').then(m => m.PlanoModule) },

      {
        path: "patrocinio",
        loadChildren: () => import('app/patrocinio/patrocinio.module').then(m => m.PatrocinioModule),
      },

      {
        path: "pmis",
        loadChildren: () => import('app/manifestacao-interesse/manifestacao-interesse.module').then(m => m.ManifestacaoInteresseModule),
      },

      {
        path: "execucao",
        loadChildren: () => import('app/execucao/execucao.module').then(m => m.ExecucaoModule),
      },

      {
        path: "prestacao-contas",
        loadChildren: () => import('app/prestacao-contas/prestacao-contas.module').then(m => m.PrestacaoContasModule),
      },

      {
        path: "habilitacao",
        loadChildren: () => import('app/habilitacao/habilitacao.module').then(m => m.HabilitacaoModule),
      },

      {
        path: "termos",
        loadChildren: () => import('app/modelo-termo/modelo-termo.module').then(m => m.ModeloTermoModule),
      },

      {
        path: "controle-interno",
        loadChildren: () => import('app/controle-interno/controle-interno.module').then(m => m.ControleInternoModule),
      },

      { path: "modelo", loadChildren: () => import('app/modelo/modelo.module').then(m => m.ModeloModule) },

      {
        path: "tributos",
        loadChildren: () => import('app/tributos/tributos.module').then(m => m.TributosModule),
      },

      { path: "frota", loadChildren: () => import('app/frota/frota.module').then(m => m.FrotaModule) },

      {
        path: "perfil-permissao",
        loadChildren: () => import('app/perfil-permissao/perfil-permissao.module').then(m => m.PerfilPermissaoModule),
      },

      {
        path: "administracao",
        loadChildren: () => import('app/administracao/administracao.module').then(m => m.AdministracaoModule),
      },

      {
        path: "pendencia",
        loadChildren: () => import('app/pendencia/pendencia.module').then(m => m.PendenciaModule),
      },

      { path: 'projetos-concluidos', loadChildren: () => import('app/projetos-concluidos/projetos-concluidos.module').then(m => m.ProjetosConcluidosModule) },
      
      // ===== MODULO ESCOLAR ==== //

      { path: 'educacao-escolar', loadChildren: () => import('app/modulo-escolar/escolar.module').then(m => m.EscolarModule) },
    ]
  },

  {
    path: "proposta",
    loadChildren: () => import('app/proposta/proposta.module').then(m => m.PropostaModule),
  },
  { path: "tutoriais-publicos", component: ConsultaPublicaTutoriaisComponent },
  { path: "modulo-nao-disponivel", component: ModuloNaoDisponivelComponent },
  { path: "**", redirectTo: "modulo-nao-disponivel" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
